import { RefObject } from "react";
import { TextInput, TextInputProps } from "react-native";

export type InputType = "text" | "number" | "password";

type InputTypeToValueTypeMap = {
  text: string;
  number: number;
  password: string;
};

export type OnChangeType<T extends InputType> = (
  value: InputTypeToValueTypeMap[T]
) => void;

export type BaseInputProps<T extends InputType> = Omit<
  TextInputProps,
  "onChange" | "value"
> & {
  testID?: string;
  name: string;
  placeholder?: string;
  value?: InputTypeToValueTypeMap[T] | null;
  type?: InputType;
  inputRef?: RefObject<TextInput | null>;
  onChange: OnChangeType<T>;
};
